import React from 'react';
import Page from "../../containers/Page/Page";
import { Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';

interface ISegmento {
    id: string;
    segmento: string;
}

function DescontosInfo() {

    const history = useHistory();

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [segmentos, setSegmentos] = React.useState<ISegmento[]>([]);

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar segmentos.
     * @param page 
     */
    async function handleFetch() {
        setLoading(true);
        try {
            const response = await api.get('propostas/create');
            setSegmentos(response.data.object.segmentos);
            setError('');
        } catch (error: any) {
            setError(error.response.data.message);
        }
        setLoading(false);
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Descontos / Segmentos
                </Typography>
            </Page.Title>
            {segmentos &&
                <Page.Section>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Segmento</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {segmentos.map((segmento) => (
                                        <TableRow
                                            key={segmento.id}
                                            hover={true}
                                            onClick={() => history.push(`/descontos/info/${segmento.id}`)}
                                        >
                                            <TableCell>{segmento.segmento}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default DescontosInfo;